// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"71":"3770a13d","362":"323a10b2","424":"c5485033","536":"b904028e","594":"29b1fdc0","613":"e7937e6f","824":"1240826b","940":"30590db5"}[chunkId] + ".chunk.css";
};